export default {
    'name': 'litigation',
    'label': 'legal.tabs.Litigation',
    'getComponent': () => import('./litigation.vue'),
    'tabIndex': 3,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/legal/litigation',
};
